import { render, staticRenderFns } from "./Qualifikation.vue?vue&type=template&id=0a17eff2&"
import script from "./Qualifikation.vue?vue&type=script&lang=js&"
export * from "./Qualifikation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports